import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http';
import { OauthService } from '../core/oauth.service';

@Injectable()

export class TokenInterceptor implements HttpInterceptor {


  constructor(private injector: Injector) {}
  intercept(req, next) {
    const authService = this.injector.get(OauthService);
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    const token = authService.getToken();

    if (token) {
      headersConfig['Authorization'] = 'bearer ' + authService.getToken();
    }


    const tokenizedReq = req.clone(
      {
        // tslint:disable-next-line:comment-format
        //setHeaders: {headersConfig}
        setHeaders: {
                      'Authorization': 'bearer ' + authService.getToken()
                    }
      }
    );
    return next.handle(tokenizedReq);
  }



}





